import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/App.css";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import AuthLayout from "./layouts/auth";
import AdminLayout from "./layouts/admin";
import RTLLayout from "./layouts/rtl";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./theme/theme";
import SharedProvider from "providers/Shared/Index";
import { Auth0Provider } from "providers/Settings/Auth0Provider";
import { ProtectedRoute } from "Routes/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import ToastProvider from "providers/Shared/ToasProvider";
import NotFound from "views/Settigns/NotFound";
import DashboardSupplier from "layouts/Supplier";
import { ChangeLayout } from "Routes/ChangeLayout";
ReactDOM.render(
  <ChakraProvider theme={theme}>
    <ToastProvider>
      <React.StrictMode>
        <Auth0Provider>
          <HashRouter>
            <SharedProvider>
              <ToastContainer />
              <Switch>
                <Route path={`/auth`} component={AuthLayout} />
                {/* <ProtectedRoute>
                  <Route path={`/admin`} component={AdminLayout} />
                </ProtectedRoute> */}
                <ProtectedRoute path="/admin">
                  <AdminLayout />
                </ProtectedRoute>
                <ProtectedRoute path="/supplier">
                  <DashboardSupplier />
                </ProtectedRoute>
                <ProtectedRoute path="/">
                  <ChangeLayout />
                </ProtectedRoute>

                {/* <ProtectedRoute> */}
                {/* <ProtectedRoute>
                  <Route path={`/supplier`} component={DashboardSupplier} />
                </ProtectedRoute> */}

                {/* </ProtectedRoute> */}
                {/* <ProtectedRoute> */}
                {/* <Route path={`/rtl`} component={AdminLayout} /> */}
                {/* </ProtectedRoute> */}
                <Route exact path={`/notfound`} component={NotFound} />
                {/* 
                <ProtectedRoute>
                  <Route exact path={"/"} component={ChangeLayout} />
                </ProtectedRoute> */}

                {/* <Redirect from="/" to="/rtl/home" /> */}
              </Switch>
            </SharedProvider>
          </HashRouter>
        </Auth0Provider>
      </React.StrictMode>
    </ToastProvider>
  </ChakraProvider>,
  document.getElementById("root")
);
